import React from "react";
import { Col, Row } from "react-bootstrap";

import Firefox from "../../Assets/About/Tools/Firefox.svg";
import Gns3 from "../../Assets/About/Tools/Gns3.webp";
import Mobax from "../../Assets/About/Tools/Mobax.webp";
import Rdm from "../../Assets/About/Tools/Rdm.webp";
import vsCode from "../../Assets/About/Tools/Vscode.svg";
import Windows from "../../Assets/About/Tools/Windows.webp";
import Zealdocs from "../../Assets/About/Tools/Zealdocs.webp";


function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons ">
        <img src={Firefox} alt="Firefox" className="tech-icon-images" />
        <div className="tech-icons-text">Firefox</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons ">
        <img src={Gns3} alt="Gns3" className="tech-icon-images" />
        <div className="tech-icons-text">Gns3</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons ">
        <img src={Mobax} alt="Mobax" className="tech-icon-images" />
        <div className="tech-icons-text">Mobaxterm</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons ">
        <img src={Rdm} alt="Remote Desktop Manager" className="tech-icon-images" />
        <div className="tech-icons-text">Remote Desktop Manager</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons ">
        <img src={vsCode} alt="vsCode" className="tech-icon-images" />
        <div className="tech-icons-text">VsCode</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Windows} alt="Windows" className="tech-icon-images" />
        <div className="tech-icons-text">Windows</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons ">
        <img src={Zealdocs} alt="Zealdocs" className="tech-icon-images" />
        <div className="tech-icons-text">Zealdocs</div>
      </Col>
    </Row>
  );
}

export default Toolstack;
